class CartDrawer extends HTMLElement{constructor(){super();this.addEventListener('keyup',(evt)=>evt.code==='Escape'&&this.close());this.querySelector('#CartDrawer-Overlay').addEventListener('click',this.close.bind(this));this.setHeaderCartIconAccessibility()}
setHeaderCartIconAccessibility(){const cartLink=document.querySelector('#cart-icon-bubble');cartLink.setAttribute('role','button');cartLink.setAttribute('aria-haspopup','dialog');cartLink.addEventListener('click',(event)=>{event.preventDefault();this.open(cartLink)});cartLink.addEventListener('keydown',(event)=>{if(event.code.toUpperCase()==='SPACE'){event.preventDefault();this.open(cartLink)}})}
open(triggeredBy){if(triggeredBy)this.setActiveElement(triggeredBy);const cartDrawerNote=this.querySelector('[id^="Details-"] summary');if(cartDrawerNote&&!cartDrawerNote.hasAttribute('role'))this.setSummaryAccessibility(cartDrawerNote);setTimeout(()=>{this.classList.add('animate','active')});this.addEventListener('transitionend',()=>{const containerToTrapFocusOn=this.classList.contains('is-empty')?this.querySelector('.drawer__inner-empty'):document.getElementById('CartDrawer');const focusElement=this.querySelector('.drawer__inner')||this.querySelector('.drawer__close');trapFocus(containerToTrapFocusOn,focusElement)},{once:!0});document.body.classList.add('overflow-hidden')}
close(){this.classList.remove('active');removeTrapFocus(this.activeElement);document.body.classList.remove('overflow-hidden')}
setSummaryAccessibility(cartDrawerNote){cartDrawerNote.setAttribute('role','button');cartDrawerNote.setAttribute('aria-expanded','false');if(cartDrawerNote.nextElementSibling.getAttribute('id')){cartDrawerNote.setAttribute('aria-controls',cartDrawerNote.nextElementSibling.id)}
cartDrawerNote.addEventListener('click',(event)=>{event.currentTarget.setAttribute('aria-expanded',!event.currentTarget.closest('details').hasAttribute('open'))});cartDrawerNote.parentElement.addEventListener('keyup',onKeyUpEscape)}
renderContents(parsedState){this.querySelector('.drawer__inner').classList.contains('is-empty')&&this.querySelector('.drawer__inner').classList.remove('is-empty');this.productId=parsedState.id;this.getSectionsToRender().forEach((section)=>{const sectionElement=section.selector?document.querySelector(section.selector):document.getElementById(section.id);sectionElement.innerHTML=this.getSectionInnerHTML(parsedState.sections[section.id],section.selector)});setTimeout(()=>{this.querySelector('#CartDrawer-Overlay').addEventListener('click',this.close.bind(this));this.open()})}
getSectionInnerHTML(html,selector='.shopify-section'){return new DOMParser().parseFromString(html,'text/html').querySelector(selector).innerHTML}
getSectionsToRender(){return[{id:'cart-drawer',selector:'#CartDrawer',},{id:'cart-icon-bubble',},]}
getSectionDOM(html,selector='.shopify-section'){return new DOMParser().parseFromString(html,'text/html').querySelector(selector)}
setActiveElement(element){this.activeElement=element}}
customElements.define('cart-drawer',CartDrawer);class CartDrawerItems extends CartItems{getSectionsToRender(){return[{id:'CartDrawer',section:'cart-drawer',selector:'.drawer__inner',},{id:'cart-icon-bubble',section:'cart-icon-bubble',selector:'.shopify-section',},]}}
customElements.define('cart-drawer-items',CartDrawerItems);
/* ============================================================
   FNF patch: lazy upsell panel + optimistic open.
   - The "Style It With"/size-protection panel is no longer server-rendered
     inside the cart-drawer section (it cost 5 all_products lookups on every
     /cart/add). It now lives in sections/cart-drawer-upsell.liquid and is
     fetched here after the drawer opens, then cached for instant re-inject
     whenever cart renders replace the drawer contents.
   - openOptimistic()/finishOptimistic()/closeOptimistic() are called by
     assets/product-form.js to open the drawer with a skeleton row the
     moment Add to cart is clicked.
   ============================================================ */
(function () {
  var CD = customElements.get('cart-drawer');
  if (!CD) return;
  var upsellCache = null;
  var refreshTimer = null;
  var upsellVisible = function () {
    return window.matchMedia('(min-width: 750px)').matches;
  };
  var injectUpsell = function (html) {
    document.querySelectorAll('[data-fnf-upsell-lazy]').forEach(function (el) {
      el.innerHTML = html;
    });
  };
  var refreshUpsell = function () {
    if (!upsellVisible()) return;
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + '?sections=cart-drawer-upsell')
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          var html = sections['cart-drawer-upsell'];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('.shopify-section');
          upsellCache = inner ? inner.innerHTML : '';
          injectUpsell(upsellCache);
        })
        .catch(function () {});
    }, 150);
  };
  CD.prototype.loadUpsell = function () {
    var slot = this.querySelector('[data-fnf-upsell-lazy]');
    if (!slot || !upsellVisible()) return;
    if (upsellCache && !slot.childElementCount) injectUpsell(upsellCache);
    refreshUpsell();
  };
  var origOpen = CD.prototype.open;
  CD.prototype.open = function (triggeredBy) {
    origOpen.call(this, triggeredBy);
    this.loadUpsell();
  };
  CD.prototype.openOptimistic = function (triggeredBy) {
    this.classList.add('fnf-loading');
    origOpen.call(this, triggeredBy);
    this.loadUpsell();
  };
  CD.prototype.finishOptimistic = function () {
    this.classList.remove('fnf-loading');
  };
  CD.prototype.closeOptimistic = function () {
    if (this.classList.contains('fnf-loading')) {
      this.classList.remove('fnf-loading');
      this.close();
    }
  };
  var setupObserver = function () {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    /* Any flow that swaps drawer innerHTML (add-to-cart section render,
       quantity change, size-protection toggle) leaves the lazy slot empty:
       re-inject the cache instantly, then refresh so state (e.g. the
       size-protection checkbox) is authoritative. */
    new MutationObserver(function () {
      var slot = drawer.querySelector('[data-fnf-upsell-lazy]');
      if (slot && !slot.childElementCount && upsellCache && upsellVisible()) {
        injectUpsell(upsellCache);
        refreshUpsell();
      }
    }).observe(drawer, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupObserver);
  } else {
    setupObserver();
  }
})();